import * as Yup from "yup";
import { EMAIL_PATTERN, MOBILE_PATTERN, NAME_PATTERN } from "./validationRegex";

export const formValidations = Yup.object({
  name: Yup.string()
    .min(2, "Name must be at least 2 characters")
    .max(50, "Name must be less than 50 characters")
    .matches(
      NAME_PATTERN,
      "Name can only contain letters and spaces, without spaces at the beginning or end"
    )
    .required("Full name is required"),

  email: Yup.string()
    .matches(EMAIL_PATTERN, "Please enter a valid email address")
    .required("Email is required"),

  contactNumber: Yup.string()
    .matches(MOBILE_PATTERN, "Please enter a valid 10-digit mobile number")
    .required("Contact number is required"),

  enquiryType: Yup.string().required("Please select an enquiry type"),

  message: Yup.string()
    .required("Message is required")
    .test(
      "min-chars",
      "Message must be at least 20 characters (excluding spaces)",
      (value) => !!value && value.replace(/\s/g, "").length >= 20
    )
    .test(
      "max-chars",
      "Message must be less than 1000 characters (excluding spaces)",
      (value) => !!value && value.replace(/\s/g, "").length <= 1000
    )
    .matches(
      /^(?=.*[A-Za-z])\s*[A-Za-z0-9][A-Za-z0-9\s\S]*[A-Za-z0-9.]\s*$/,
      "Message must start with a letter or number, contain alphabets, and end with a letter, number, or period."
    ),
});
